<template>
    <div class="apprentice-simple-card col-md-12">
        <design-2021-apprentice-data-table
            class="quest-students"
            v-if="filteredUsers.length"
            :fields="filteredUsersTableFields"
            :items="filteredUsers">
            <template #options>
                <div class="quest-options">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="groupSelected"
                        :options="groupOptions"></b-form-select>
                    <b-button
                        class="btn-add-student"
                        variant="primary"
                        @click="showModal(true)">
                        {{ $t('quest.add_students') }}
                    </b-button>
                </div>
            </template>
            <template #cell(actions)="row">
                <div class="actions">
                    <b-button
                        class="btn btn-remove"
                        variant="danger-icon-only"
                        @click="removeStudent(row.item.id)"></b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-students-list"
            v-else>
            <div class="header">
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="groupSelected"
                    :options="groupOptions"></b-form-select>
                <b-button
                    class="btn-add btn-add-student"
                    variant="primary"
                    @click="showModal(true)">
                    {{ $t('quest.add_students') }}
                </b-button>
            </div>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('quest.no_students_found') }}</div>
        </div>

        <b-modal
            id="quest-edit-student-add-modal"
            v-model="show_modal"
            :title="$t('quest.add_student')"
            :ok-title="$t('common.close')"
            size="lg"
            ok-only
            modal-class="apprentice-default-modal">
            <!-- name -->
            <div class="row">
                <div class="col-md-12">
                    <v-server-table
                        ref="possibleuserstable"
                        :url="routes.questEditUsersPossible(questId)"
                        :columns="possibleColumns"
                        :options="possibleOptions"
                        name="quest-add-students-table">
                        <span
                            slot="actions"
                            slot-scope="{ row }">
                            <b-button
                                class="btn-hand-pointer btn-select-student"
                                v-b-tooltip.hover
                                variant="primary-icon-only"
                                @click="addStudent(row.id)"
                                :title="$t('common.choose')"></b-button>
                        </span>
                    </v-server-table>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['questId', 'groups', 'users'],
    name: 'design-2021-quest-edit-students-component',
    data() {
        var groupOptions = [];
        this.groups.forEach((obj) => {
            groupOptions.push({ value: obj.id, text: obj.name });
        });

        return {
            groupOptions: groupOptions,
            curusers: this.users,
            filteredUsersTableFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: 'E-mail',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            usersColumns: ['full_name', 'email', this.$t('common.actions')],
            usersOptions: {
                headings: {
                    full_name: this.$t('common.name'),
                    email: 'E-mail',
                    actions: this.$t('common.actions'),
                },
                sortable: ['full_name', 'email'],
                filterable: ['full_name', 'email'],
            },
            groupSelected: this.groups[0].id,
            possibleColumns: ['full_name', 'email', 'actions'],
            possibleOptions: {
                sortIcon: {
                    base: 'fad',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                headings: {
                    full_name: this.$t('common.name'),
                    email: 'E-mail',
                    actions: this.$t('common.actions'),
                },
                sortable: ['full_name', 'email'],
                filterable: ['full_name', 'email'],
                saveState: true,
            },
            options: {},
            show_modal: false,
        };
    },
    methods: {
        showModal(bool) {
            this.show_modal = bool;
        },
        removeStudent(id) {
            this.alert
                .confirm(this.$t('quest.delete_student'), this.$t('quest.are_you_sure_you_want_to_delete_this_student'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.questEditUserDelete(this.questId, id)).then(
                            (response) => {
                                this.curusers = this.curusers.filter((user) => user.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        addStudent(id) {
            this.alert.saving();

            var data = {
                id: id,
                group_id: this.groupSelected,
            };

            this.axios.post(this.routes.questEditUserAdd(this.questId), data).then(
                (response) => {
                    this.curusers.push(response.data.user);
                    this.$refs.possibleuserstable.refresh();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    computed: {
        filteredUsers() {
            return this.curusers.filter((user) => {
                var mainGroup = false;
                var groupSelected = this.groupSelected;
                this.groups.forEach((obj) => {
                    if (obj.parent_id == null && groupSelected == obj.id) mainGroup = true;
                });

                if (mainGroup) return true;

                if (user.group_id != this.groupSelected) return false;

                return true;
            });
        },
    },
};
</script>

<style scoped lang="scss">
.quest-students > .apprentice-table-call-to-actions {
    flex: 1 1 auto;
    margin-left: auto;
}

.quest-options {
    flex-direction: column;
}

.quest-options select {
    width: auto;
    margin-bottom: 15px;
}

.no-students-found {
    display: flex;
    flex-direction: column;
}

.no-students-found .quest-options {
    margin-bottom: 10px;
}

.no-students-found .quest-options select {
    width: 100%;
}

.btn-add-student {
    width: 100%;
}

.empty-students-list {
    margin-top: $grid-gutter-width;
    margin-bottom: $grid-gutter-width;
    align-items: initial;

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;

        select,
        button {
            width: 100%;
        }
    }
}

@media (min-width: 576px) {
    .quest-options {
        flex-direction: row;
    }

    .quest-options select {
        margin-right: 15px;
        margin-bottom: 0;
    }

    .no-students-found .quest-options {
        justify-content: flex-end;
        display: flex;
    }

    .no-students-found .quest-options select {
        width: auto;
    }

    .btn-add-student {
        width: auto;
    }

    .empty-students-list {
        align-items: center;
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

        .header {
            flex-direction: row;
            align-self: flex-end;
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

            select,
            button {
                width: auto;
                flex: 0 0 auto;
                max-width: 250px;
                align-self: baseline;
                margin-bottom: 0;
            }

            > select,
            > button,
            > div {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}

@media (min-width: 768px) {
    .quest-students > .apprentice-table-filters {
        flex: 1 0 100%;
        margin-bottom: 15px;
    }
}

@media (min-width: 992px) {
    .quest-students > .apprentice-table-filters {
        flex: 0 1 auto;
        margin-bottom: 0;
    }
}
</style>
